import { useEffect, useState } from "react";
import { PlayCircle, Film } from "lucide-react";
import { api } from "@/lib/api";

const API = process.env.REACT_APP_BACKEND_URL;

export function ComeFunzionaVideo() {
  const [s, setS] = useState(null);
  useEffect(() => { api.get("/public/come-funziona").then((r) => setS(r.data)).catch(() => {}); }, []);
  if (!s) return null;
  const pronto = s.stato === "pronto";
  return (
    <section id="video" className="px-6 sm:px-12 py-20 bg-white" data-testid="come-funziona-section">
      <div className="max-w-6xl">
        <p className="text-xs font-semibold uppercase tracking-[0.2em] text-[#003087]">Come funziona · il video</p>
        <h2 className="font-heading text-base md:text-lg text-slate-600 mt-2">Tutte le fasi in {s.scene.length} scene: dallo stabilimento all'aggiudicazione.</h2>
        <div className="grid lg:grid-cols-[1.5fr_1fr] gap-8 mt-8 items-start">
          <div className="rounded-2xl overflow-hidden bg-slate-900 aspect-video relative shadow-xl">
            {pronto ? <video src={`${API}/api/public/come-funziona/video`} controls playsInline preload="metadata" poster="/img/forte-dei-marmi.jpg" className="h-full w-full object-cover" data-testid="come-funziona-video" />
              : <div className="absolute inset-0 flex flex-col items-center justify-center text-white/70 text-sm gap-2" data-testid="come-funziona-placeholder"><Film size={36} strokeWidth={1.2} /> {s.stato === "in_corso" ? `Video in produzione… ${s.scene_pronte || 0}/${s.scene.length} scene pronte` : "Video in arrivo"}</div>}
          </div>
          <ol className="space-y-2" data-testid="come-funziona-scene">
            {s.scene.map((c, i) => (
              <li key={c.key} className="flex gap-3 rounded-xl border border-slate-200 p-3 hover:border-[#003087]/40 transition-colors"><span className="h-7 w-7 shrink-0 rounded-full bg-[#003087] text-white text-xs flex items-center justify-center">{i + 1}</span><div><div className="text-sm font-medium text-slate-900 flex items-center gap-1.5"><PlayCircle size={13} className="text-[#003087]" /> {c.titolo}</div><p className="text-xs text-slate-600 mt-0.5 leading-relaxed">{c.voce}</p></div></li>))}
          </ol>
        </div>
      </div>
    </section>
  );
}
